import React, { useState } from "react";
import { Col, Input, Label, Row } from "reactstrap";
import ButtonIcon from "./ButtonIcon";

const ReferralCode = ({ referralCode,setReferralCode, isApplyBtnShow = false }) => {
  const [referralCodeTemp, setReferralCodeTemp] = useState({
    currentValue: referralCode || "",
    lastValue: "",
    steps: 1,
  });

  return (
    <>
      <Row className="">
        <Col>
          <Label for="referral_code_label">
            Do you have a referral code to apply?
          </Label>
          <Input
            size={"sm"}
            value={referralCodeTemp.currentValue}
            onChange={(e) => {
              setReferralCodeTemp({
                ...referralCodeTemp,
                currentValue: e.target.value,
                steps: 2,
              });

              if (!isApplyBtnShow) {
                setReferralCode(e.target.value);
              }
            }}
            name="referral_code"
            id="referral_code"
            placeholder="Referral Code"
          />
        </Col>
        {isApplyBtnShow && (
          <Col
            sm={12}
            md={6}
            lg={4}
            className="mt-sm-2 mb-sm-1 d-md-flex align-items-md-end d-lg-flex align-items-lg-end"
          >
            <ButtonIcon
              color={"success"}
              size="sm"
              icon="Sync"
              className="ext-light"
              iconClassName="fs--2"
              onClick={() => {
                if (referralCodeTemp.currentValue) {
                  setReferralCodeTemp({
                    ...referralCodeTemp,
                    lastValue: referralCodeTemp.currentValue,
                    steps: 3,
                  });
                  if (setReferralCode) {
                    setReferralCode(referralCodeTemp.currentValue);
                  }
                }
              }}
              disabled={referralCodeTemp.steps == 3}
            >
              {referralCodeTemp.steps == 1 && "Apply"}
              {referralCodeTemp.steps == 2 && "Apply"}
              {referralCodeTemp.steps == 3 && "Applied"}
            </ButtonIcon>
          </Col>
        )}
      </Row>
    </>
  );
};

export default ReferralCode;
